import en from '@assets/i18n/locales/i18n-en.json';
import ja from '@assets/i18n/locales/i18n-ja.json';
import cn from '@assets/i18n/locales/i18n-zh.json';
import uienLocale from '@/components/ptengine-ui/components/locale/lang/en';
import uijaLocale from '@/components/ptengine-ui/components/locale/lang/ja';
import uicnLocale from '@/components/ptengine-ui/components/locale/lang/zh-cn';
import masterI18n from '@master/static/i18n/index';
import landingPageI18n from '@landingPage/static/i18n/index';
import experienceI18n from '@experience/static/i18n/index';

export default [
    {
        key: 'EN',
        file: Object.assign(
            {},
            en,
            masterI18n.en,
            landingPageI18n.en,
            experienceI18n.en,
            uienLocale
        ),
        name: 'English',
        dayjsKey: 'en',
        fallbackLocale: true,
        link: 'https://x.ptengine.com'
    },
    {
        key: 'JP',
        file: Object.assign(
            {},
            ja,
            masterI18n.jp,
            landingPageI18n.jp,
            experienceI18n.jp,
            uijaLocale
        ),
        isDefault: true,
        name: '日本語',
        dayjsKey: 'ja',
        link: 'https://x.ptengine.jp'
    },
    {
        key: 'ZH',
        file: Object.assign(
            {},
            cn,
            masterI18n.cn,
            landingPageI18n.cn,
            experienceI18n.cn,
            uicnLocale
        ),
        name: '中文',
        dayjsKey: 'zh-cn',
        link: 'https://x.ptengine.com'
    }
];
